import { ExportReportRequest } from '@/DTOS/MentenancePlanning/ExportReportRequest';
import { Search } from '@/DTOS/MentenancePlanning/Search';
import request from '../../utils/request';

const MentenancePlanningService = {
  searchAll: (search: Search) => {
    return request('/mentenancePlanning/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
  searchScheduled: (search: Search) => {
    return request('/mentenancePlanning/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
  searchRecheduled: (search: Search) => {
    return request('/mentenancePlanning/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
  searchHistory: (search: Search) => {
    return request('/mentenancePlanning/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
  searchMyActiveMentenancePlanning: (search: Search) => {
    return request('/mentenancePlanning/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
  searchMyHistoryMentenancePlanning: (search: Search) => {
    return request('/mentenancePlanning/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
  searchMentenancePlanningByWorkPlace: (search: Search) => {
    return request('/mentenancePlanning/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
  searchInterventionOverview: (search: Search) => {
    return request('/mentenancePlanning/searchInterventionOverview', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
  searchInterventionOverviewItems: (search: Search) => {
    return request('/mentenancePlanning/searchInterventionOverviewItems', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  exportReport: (exportRequest: ExportReportRequest) => {
    return request(
      '/mentenancePlanning/exportReport',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: { ...exportRequest } }),
      },
      true
    );
  },

  delete: (id: string) => {
    return request('/mentenancePlanning/delete', {
      method: 'POST',
      body: JSON.stringify({ request: { ids: [id] } }),
    });
  },

  bulkUpdate: (items: { id: string; appointment?: string; assignedTechnicianId?: string }[]) => {
    return request('/mentenancePlanning/bulkUpdate', {
      method: 'POST',
      body: JSON.stringify({ request: { items } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    formData: {
      number?: any;
      contractId?: any;
      status?: any;
      statusId?: any;
      company?: any;
      companyId?: any;
      workPlace?: any;
      workPlaceId?: any;
      workPlaceIds?: any;
      interventionFile?: any;
      interventionFileId?: any;
      mentenancePlanningSystemTypes?: any;
      registeredByUser?: any;
      registeredByUserId?: any;
      assignedTechnician?: any;
      assignedTechnicianId?: any;
      finalDate?: any;
      periodicity?: any;
      lastMentenance?: any;
      dateEnd?: any;
      appointment?: any;
      intervalTimetable?: any;
      history?: any;
    }
  ) => {
    // const handleFieldValue = (fieldValue: any) => {
    //   if (Array.isArray(fieldValue)) {
    //     return fieldValue;
    //   } else {
    //     return [fieldValue];
    //   }
    // };
    return request('/mentenancePlanning/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          number: formData.number,
          contractId: formData.contractId,
          statusId: formData.statusId,
          status: formData.status,
          companyId: formData.companyId,
          company: formData.company,
          workPlaceId: formData.workPlaceId,
          workPlaceIds: formData.workPlaceIds,
          workPlace: formData.workPlace,
          interventionFileId: formData.interventionFileId,
          interventionFile: formData.interventionFile,
          mentenancePlanningSystemTypes: formData.mentenancePlanningSystemTypes,
          registeredByUserId: formData.registeredByUserId,
          registeredByUser: formData.registeredByUser,
          assignedTechnicianId: formData.assignedTechnicianId,
          assignedTechnician: formData.assignedTechnician,
          finalDate: formData.finalDate,
          periodicity: formData.periodicity,
          lastMentenance: formData.lastMentenance,
          dateEnd: formData.dateEnd,
          appointment: formData.appointment,
          intervalTimetable: formData.intervalTimetable,
          history: formData.history,
        },
      }),
    });
  },

  upsertMultiple: (
    formData: {
      number?: any;
      contractId?: any;
      status?: any;
      statusId?: any;
      company?: any;
      companyId?: any;
      workPlace?: any;
      workPlaceId?: any;
      workPlaceIds?: any;
      interventionFile?: any;
      interventionFileId?: any;
      mentenancePlanningSystemTypes?: any;
      registeredByUser?: any;
      registeredByUserId?: any;
      assignedTechnician?: any;
      assignedTechnicianId?: any;
      finalDate?: any;
      periodicity?: any;
      lastMentenance?: any;
      dateEnd?: any;
      appointment?: any;
      intervalTimetable?: any;
      history?: any;
    }
  ) => {
    return request('/mentenancePlanning/upsertMultiple', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: '',
          number: formData.number,
          contractId: formData.contractId,
          statusId: formData.statusId,
          status: formData.status,
          companyId: formData.companyId,
          company: formData.company,
          workPlaceId: formData.workPlaceId,
          workPlaceIds: formData.workPlaceIds,
          workPlace: formData.workPlace,
          interventionFileId: formData.interventionFileId,
          interventionFile: formData.interventionFile,
          mentenancePlanningSystemTypes: formData.mentenancePlanningSystemTypes,
          registeredByUserId: formData.registeredByUserId,
          registeredByUser: formData.registeredByUser,
          assignedTechnicianId: formData.assignedTechnicianId,
          assignedTechnician: formData.assignedTechnician,
          finalDate: formData.finalDate,
          periodicity: formData.periodicity,
          lastMentenance: formData.lastMentenance,
          dateEnd: formData.dateEnd,
          appointment: formData.appointment,
          intervalTimetable: formData.intervalTimetable,
          history: formData.history,
        },
      }),
    });
  },

  sendNotification: (formData: {
    id: any;
    number?: any;
    status?: any;
    statusId?: any;
    company?: any;
    companyId?: any;
    workPlace?: any;
    workPlaceId?: any;
    interventionFile?: any;
    interventionFileId?: any;
    mentenancePlanningSystemTypes?: any;
    registeredByUser?: any;
    registeredByUserId?: any;
    assignedTechnician?: any;
    assignedTechnicianId?: any;
    finalDate?: any;
    periodicity?: any;
    lastMentenance?: any;
    dateEnd?: any;
    modifyDate?: any;
    appointment?: any;
    intervalTimetable?: any;
    history?: any;
  }) => {
    return request('/telegram/send-reschedule-notification', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: formData.id,
          number: formData.number,
          statusId: formData.statusId,
          status: formData.status,
          companyId: formData.companyId,
          company: formData.company,
          workPlaceId: formData.workPlaceId,
          workPlace: formData.workPlace,
          interventionFileId: formData.interventionFileId,
          interventionFile: formData.interventionFile,
          mentenancePlanningSystemTypes: formData.mentenancePlanningSystemTypes,
          registeredByUserId: formData.registeredByUserId,
          registeredByUser: formData.registeredByUser,
          assignedTechnicianId: formData.assignedTechnicianId,
          assignedTechnician: formData.assignedTechnician,
          finalDate: formData.finalDate,
          periodicity: formData.periodicity,
          lastMentenance: formData.lastMentenance,
          dateEnd: formData.dateEnd,
          modifyDate: formData.modifyDate,
          appointment: formData.appointment,
          intervalTimetable: formData.intervalTimetable,
          history: formData.history,
        },
      }),
    });
  },
};

export default MentenancePlanningService;
